module.exports = __webpack_public_path__ + "img/Partner.96806bf4.gif";